import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=0fe92f05&"
import script from "./ReservationDetail.vue?vue&type=script&lang=js&"
export * from "./ReservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=0fe92f05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports